import {
	Toast,
	ToastClose,
	ToastDescription,
	ToastProvider,
	ToastTitle,
	ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
	const { toasts, dismiss } = useToast();

	return (
		<ToastProvider>
			<ToastViewport>
				{toasts.map(({ id, title, description, action, ...props }) => {
					return (
						<Toast
							key={id}
							{...props}
							className={props.variant === "destructive" ? "text-white" : ""}
						>
							<div className="grid gap-1">
								{title && <ToastTitle>{title}</ToastTitle>}
								{description && (
									<ToastDescription>{description}</ToastDescription>
								)}
							</div>
							{action}
							<ToastClose
								onClick={() => {
									dismiss(id);
								}}
							/>
						</Toast>
					);
				})}
			</ToastViewport>
		</ToastProvider>
	);
}
